import styled from "styled-components";

const StyledInputFieldMessage = styled.div`
  display: block;
  margin: 4px 16px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  margin-bottom: 16px;
  color: ${(props) => props.theme.palette.error};
`;

export default StyledInputFieldMessage;
